import axios from "@/request";
import qs from "qs";

export default {
  async list(params: any) {
    return axios.get("stadium-shutdowns-setting/list", { params });
  },
  async add(params: any) {
    return axios.post("stadium-shutdowns-setting/add", qs.stringify(params));
  },
  async edit(params: any) {
    return axios.post("stadium-shutdowns-setting/edit", qs.stringify(params));
  },
  async detail(params: any) {
    return axios.get("stadium-shutdowns-setting/detail", { params });
  },
  async delete(params: any) {
    return axios.post("stadium-shutdowns-setting/delete", qs.stringify(params));
  }
};
